import { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { listDevInquiries, listInquiries } from '../api/inquiriesApi';

/**
 * 設定画面のバッジ用の数。unread = 自分のお問い合わせへの、未読の返信。needsReply = （開発者だけ）返信待ちの数。
 * 取れなくても 0 のまま（バッジが出ないだけで、画面は止めない）。ページを開いたときに 1 回だけ取る。
 */
export function useInquiryBadges(isDev = false) {
  const { user } = useAuth();
  const [badges, setBadges] = useState({ unread: 0, needsReply: 0 });

  useEffect(() => {
    if (!user) return undefined;
    let cancelled = false;
    const mine = listInquiries().then((r) => r.unreadCount || 0).catch(() => 0);
    const dev = isDev ? listDevInquiries('needs_reply').then((r) => r.needsReplyCount || 0).catch(() => 0) : Promise.resolve(0);
    Promise.all([mine, dev]).then(([unread, needsReply]) => {
      if (!cancelled) setBadges({ unread, needsReply });
    });
    return () => {
      cancelled = true;
    };
  }, [user, isDev]);

  return badges;
}
